// ── COMPANY INFO ──────────────────────────────────────────────────────────────
export const COMPANY = {
  name: 'Bright Machineries',
  tagline: 'Used Machine Seller',
  established: '2004',
  phone: '+917506760967',
  whatsapp: '917506760967',
  email: 'brightmachineri@gmail.com',
  address: 'Gala-01, Kirvali Gaon, Adiwali, Taloja Panvel Raigad Patnoli 410208',
  mapLink: 'https://maps.google.com',
  hours: 'Mon – Sat: 9 AM – 6 PM',
  instagram: '',
  linkedin: '',
};

// ── MACHINE CATEGORIES ────────────────────────────────────────────────────────
export const CATEGORIES = [
  { id: 'cnc',        label: 'CNC Machines',         icon: '⚙️' },
  { id: 'lathe',      label: 'Lathe Machines',        icon: '🔩' },
  { id: 'manual',   label: 'Manual Machines', icon: '🏗️' },
  { id: 'milling',    label: 'Milling Machines',      icon: '🏭' },
  { id: 'grinding',   label: 'Grinding Machines',     icon: '🔧' },
  { id: 'press',      label: 'Pressing Machines',       icon: '🔨' },
  { id: 'welding',    label: 'Truning Machines',     icon: '🔥' },
  { id: 'drilling',   label: 'Drilling Machines',     icon: '🪛' },
 // { id: 'compressor', label: 'Compressors',           icon: '💨' },
 //{ id: 'forklift',   label: 'Forklifts & Material Handling', icon: '🏗️' },
 // { id: 'generator',  label: 'Generators & Power',   icon: '⚡' },
  { id: 'other',      label: 'Other Machines',       icon: '📦' },
];

export const STATUSES   = ['Available', 'Reserved', 'Sold'];
export const CONDITIONS = ['Excellent', 'Good', 'Fair', 'For Parts'];

export const SEED_MACHINES = [
 
];
